import React from 'react';

import {ErrorBoundary} from 'app/general/structures/ErrorBoundary';
import {FlexPanel} from 'app/general/structures/FlexPanel';
import {SPErrorPage} from 'app/general/structures/SPErrorPage';

import {NavSidebarContainer} from './NavSidebarContainer';
import {SPHeader} from './SPHeader';

interface Props {
  children: React.ReactNode;
}

export function SPFrame({children}: Props): JSX.Element {
  const [isSidebarOpened, setSidebarOpened] = React.useState(false);
  const toggleSidebar = () => setSidebarOpened(!isSidebarOpened);

  return (
    <FlexPanel
      type="vertical"
      secondary={
        <ErrorBoundary name="sp-header">
          <SPHeader
            onToggleSidebar={toggleSidebar}
            sidebarOpened={isSidebarOpened}
          />
        </ErrorBoundary>
      }
      secondaryZindex="10"
    >
      <NavSidebarContainer onToggle={toggleSidebar} opened={isSidebarOpened}>
        <ErrorBoundary name="page" ErrorComponent={SPErrorPage}>
          {children}
        </ErrorBoundary>
      </NavSidebarContainer>
    </FlexPanel>
  );
}
